import React from 'react';
import { InView as IntersectionObserver } from 'react-intersection-observer';
import cn from 'classnames';

import { IPlayer } from '../../types';
import usePinningWrapper from './usePinningWrapper';

import './pinningWrapper.scss';

interface Props {
    matchId: string;
    streamUrl: string | null;
    player: IPlayer | null;
    children: (
        isPinned: boolean,
        handleStreamUnpin: () => void
    ) => JSX.Element | null;
    onStreamUnpin: () => void;
    type: 'desktop' | 'mobile';
}

const PinnedStream: React.FC<Props> = ({
    matchId,
    streamUrl,
    children,
    player,
    onStreamUnpin,
    type,
}) => {
    const {
        handleIntersection,
        handleStreamUnpin,
        isPinned,
    } = usePinningWrapper({
        matchId,
        streamUrl,
        player,
        onStreamUnpin,
        type,
    });

    return (
        <IntersectionObserver
            styleName="container"
            onChange={handleIntersection}
            threshold={[0, 1]}
        >
            <div
                styleName="wrapper"
                className={cn('__app-PinningWrapper-wrapper', {
                    '__app-PinningWrapper-wrapper-isPinned': isPinned,
                })}
            >
                {children(isPinned, handleStreamUnpin)}
            </div>
        </IntersectionObserver>
    );
};

export default PinnedStream;
